import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProductSection from './components/ProductSection';
import FeaturesSection from './components/FeaturesSection';
import PurchaseSection from './components/PurchaseSection';
import ReviewsSection from './components/ReviewsSection';
import BrandStorySection from './components/BrandStorySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <ProductSection />
        <FeaturesSection />
        <PurchaseSection />
        <ReviewsSection />
        <BrandStorySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
